import type { SVGProps } from 'react'
const SvgHomePin = (props: SVGProps<SVGSVGElement>) => (
  <svg height="1em" viewBox="0 0 18 18" width="1em" xmlns="http://www.w3.org/2000/svg" {...props}>
    <mask
      height={18}
      id="home-pin_svg__a"
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
      width={18}
      x={0}
      y={0}
    >
      <path d="M0 0h18v18H0z" />
    </mask>
    <g mask="url(#home-pin_svg__a)">
      <path d="M6.772 9.683h1.545v-1.91h1.366v1.91h1.545V6.196L9 4.71 6.772 6.196zM9 14.392q2.256-2.065 3.351-3.724t1.095-3.036q0-2.012-1.287-3.295-1.288-1.283-3.16-1.283-1.87 0-3.158 1.283T4.554 7.632q0 1.376 1.095 3.034Q6.744 12.322 9 14.392m0 2.26q-3.09-2.613-4.621-4.828Q2.848 9.61 2.848 7.633q0-2.873 1.855-4.58Q6.559 1.349 9 1.349q2.442 0 4.297 1.705t1.855 4.58q0 1.977-1.53 4.192Q12.09 14.039 9 16.653" />
    </g>
  </svg>
)
export default SvgHomePin
